/** One string per place, so a column keeps its element across renders and two places that are the
 *  same destination are told apart from two that merely look alike. */
export const placeKey = (p) => p.k === 'hub'
    ? 'hub'
    : p.k === 'chat'
        ? `chat:${p.id}`
        : p.k === 'run'
            ? `run:${p.runId}`
            : p.k === 'viewer'
                ? `viewer:${p.runId}`
                : `tree:${p.root}`;
export function artifactOf(deliverableJson) {
    const raw = deliverableJson.trim();
    if (!raw)
        return undefined;
    let parsed;
    try {
        parsed = JSON.parse(raw);
    }
    catch {
        return undefined; // a deliverable held by the platform, or plain prose — neither is an artifact
    }
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed))
        return undefined;
    const o = parsed;
    if (typeof o.source !== 'string' || !o.source.trim())
        return undefined;
    const source = o.source;
    // The declaration WITHOUT the program in it: repeating a 12,000-character module inside the
    // object beside it is the tab nobody reads, and it is what made the return unreviewable already.
    const { source: _omit, ...rest } = o;
    return {
        source,
        title: typeof o.title === 'string' ? o.title : '',
        config: o.config ?? {},
        /*
         * A GLYPH EACH, because in a narrow column the label is the first thing to go.
         *
         * The picker collapses to icons at the width a column can actually be dragged to, and two
         * documents wearing the same page icon collapse into one control drawn twice — the reader can
         * see there are two and not which is which. The program takes the code mark this app already
         * uses for a statechart and a PLC program; the declaration keeps the page, because that is what
         * it is.
         */
        docs: [
            { id: 'source', label: 'Source', text: source, lang: 'js', icon: 'code-xml' },
            { id: 'declaration', label: 'Declaration', text: JSON.stringify(rest, null, 2), lang: 'json', icon: 'file-text' },
        ],
    };
}
//# sourceMappingURL=places.js.map